<template>
	<Autocomplete
		v-model="selected"
		:display-name="label"
		:icon="icon"
		:label="label"
		:name="name"
		:endpoint="endpoint"
		:item-title="
			(item: Api.PropertyManager) => personBuildFullname(item.person)
		"
		v-bind="$attrs"
		:multiple="multiple"
		:chips="multiple"
		:params="{
			od: 'ASC',
			of: 'person.lastname',
		}"
		data-test="propertymanagers-autocomplete"
	>
		<template #append>
			<slot name="append"> </slot>
		</template>
	</Autocomplete>
</template>

<script setup lang="ts">
import { personBuildFullname } from '@/filters'
import Autocomplete from '../Validation/Autocomplete.vue'

const { endpoint } = defineProps({
	icon: {
		default: 'fa fa-fw fas fa-users',
		type: String,
	},
	label: {
		default: 'Hausverwalter',
		type: String,
	},
	name: {
		default: 'propertyManagers',
		type: String,
	},
	endpoint: {
		default: 'propertymanagers',
		type: String,
	},
	multiple: {
		default: false,
		type: Boolean,
	},
})

const selected = defineModel()
</script>

<style scoped></style>
